import {ebus} from '../vendor/ebus';
import Vue from 'vue'
import VueRouter from 'vue-router'
import {getGlobalValue} from "@/util/globalState";
import Home from '../views/Home.vue'
import OrderSummary from "../views/OrderSummary";
import store from '../store/store'
import * as util from "@/vendor/util";
import * as navigationState from "../vendor/navigationState";
import NotFound from "../views/NotFound";
import Sortiment from "../views/Sortiment";
// import Einstellungen from "../views/Einstellungen";
// import Search from "../views/Search";
import Speisen from "../views/Speisen";
import Getraenke from "../views/Getraenke";
import SpeisenProdukte from "../views/SpeisenProdukte";
import GetraenkeProdukte from "../views/GetraenkeProdukte";
import ItemDetail from "../views/ItemDetail";
import DrinkItemDetail from "../views/DrinkItemDetail";
import CheckoutTakeawayMitOnlinePayment from "../views/CheckoutTakeawayMitOnlinePayment";
import CheckoutInhouse from "../views/CheckoutInhouse";
import CheckoutInhouseMitOnlinePayment from "../views/CheckoutInhouseMitOnlinePayment";
import CheckoutTakeawayOhnePayment from "../views/CheckoutTakeawayOhnePayment";
import OrderDetail from "../views/OrderDetail";
import CheckoutDeliveryMitOnlinePayment from "../views/CheckoutDeliveryMitOnlinePayment";
import CheckoutDigitalMitOnlinePayment from "../views/CheckoutDigitalMitOnlinePayment";
import Stempelkarte from "../stempelkarte/Stempelkarte";
// import MobileCheckoutInhouseMitOnlinePayment from "../views/MobileCheckoutInhouseMitOnlinePayment";
import PaymentMethods from "@/views/PaymentMethods.vue";
import MyLieferzeiten from "@/components/MyLieferzeiten.vue";
import CheckoutInhouseMitOnlinePaymentTip from "@/views/CheckoutInhouseMitOnlinePaymentTip.vue";
import RatingFeedback from "@/feedback/RatingFeedback.vue";
import CheckoutKioskInhouse from "../kiosk/CheckoutKioskInhouse.vue";
import CheckoutKioskInhouseTip from "../kiosk/CheckoutKioskInhouseTip.vue";
import CheckoutKioskTakeAway from "../kiosk/CheckoutKioskTakeAway.vue";
import DiscountsDebugpage from "../discounts/DiscountsDebugpage.vue";
import {removeGlobalKey} from "../util/globalState";
import CheckoutDigitalOhnePayment from "../views/CheckoutDigitalOhnePayment.vue";

// import {handleHashChange} from "../firebase/firebaseUtil";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/DiscountsDebugpage',
    name: 'DiscountsDebugpage',
    component: DiscountsDebugpage
  },
  {
    path: '/KioskSplashScreen',
    name: 'KioskSplashScreen',
    component: () => import(/* webpackChunkName: "KioskSplashScreen" */ '../kiosk/KioskSplashScreen.vue')
  },
  {
    path: '/KioskUseCaseSelection',
    name: 'KioskUseCaseSelection',
    component: () => import(/* webpackChunkName: "KioskUseCaseSelection" */ '../kiosk/KioskUseCaseSelection.vue')
  },
  {
    path: '/SetupKiosk',
    name: 'SetupKiosk',
    component: () => import(/* webpackChunkName: "SetupKiosk" */ '../kiosk/SetupKiosk.vue')
  },
  {
    path: '/ShowDisplaySize',
    name: 'ShowDisplaySize',
    component: () => import(/* webpackChunkName: "ShowDisplaySize" */ '../views/ShowDisplaySize.vue')
  },

  // {
  //     path: '/Produkte',
  //     name: 'Produkte',
  //     component: Produkte
  // },
  {
    path: '/Speisen',
    name: 'Speisen',
    component: Speisen,
  },
  {
    path: '/Getraenke',
    name: 'Getraenke',
    component: Getraenke,
    meta: {
      title: 'Getränke'
    },
  },
  {
    path: '/Speisen/:catname',
    name: 'SpeisenProdukte',
    component: SpeisenProdukte,
    meta: {
      title: 'Speisen'
    },
    // meta: {
    //     title: 'Produkte'
    // }
  },
  {
    path: '/Getraenke/:catname',
    name: 'GetraenkeProdukte',
    component: GetraenkeProdukte,
    meta: {
      title: 'Getränke'
    },
    // meta: {
    //     title: 'Produkte'
    // }
  },

  // {
  //     path: '/Suche',
  //     name: 'Suche',
  //     component: Search,
  //     // route level code-splitting
  //     // this generates a separate chunk (about.[hash].js) for this route
  //     // which is lazy-loaded when the route is visited.
  //     // component: () => import(/* webpackChunkName: "search" */ '../views/Search'),
  // },
  {
    path: '/Sortiment',
    name: 'Sortiment',
    component: Sortiment,
    meta: {
      title: 'Sortiment'
    },
  },
  {
    path: '/Korb',
    name: 'Korb',
    component: OrderSummary
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "orderSummary" */ './views/OrderSummary')
  },
  // {
  //     path: '/Einstellungen',
  //     name: 'Einstellungen',
  //     component: Einstellungen
  //     // route level code-splitting
  //     // this generates a separate chunk (about.[hash].js) for this route
  //     // which is lazy-loaded when the route is visited.
  //     // component: () => import(/* webpackChunkName: "einstellungen" */ '../views/Einstellungen'),
  // },
  {
    path: '/Cookies',
    name: 'Cookies',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "cookies" */ '../views/Cookies'),
  },
  {
    path: '/Abholzeiten',
    name: 'Abholzeiten',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Abholzeiten" */ '../views/Abholzeiten')
  },
  {
    path: '/Lieferzeiten',
    name: 'Lieferzeiten',
    component: MyLieferzeiten,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "Abholzeiten" */ '../views/...')
  },
  // {
  //     path: '/Oeffnungszeiten',
  //     name: 'Oeffnungszeiten',
  //     meta: {
  //         title: 'Öffnungszeiten'
  //     },
  //     // route level code-splitting
  //     // this generates a separate chunk (about.[hash].js) for this route
  //     // which is lazy-loaded when the route is visited.
  //     component: () => import(/* webpackChunkName: "PageOeffnungszeiten" */ '../views/PageOeffnungszeiten')
  // },
  {
    path: '/Speise/:itemId',
    name: 'Speise',
    component: ItemDetail,
    meta: {
      title: 'Artikel'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "itemDetail" */ '../views/ItemDetail')
  },
  {
    path: '/Getraenk/:itemId',
    name: 'Getraenk',
    component: DrinkItemDetail,
    meta: {
      title: 'Artikel'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "DrinkItemDetail" */ '../views/DrinkItemDetail')
  },
  {
    path: '/Aktuelles',
    name: 'Aktuelles',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "aktuelles" */ '../news/Aktuelles'),
  },
  {
    path: '/Nachricht/:newsId',
    name: 'Nachricht',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "nachricht" */ '../views/Nachricht'),
  },
  {
    path: '/Page/:name',
    name: 'Page',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "page" */ '../views/Page'),
  },
  {
    path: '/rating-feedback',
    name: 'RatingFeedback',
    component: RatingFeedback,
  },
  {
    path: '/Registrierung',
    name: 'Registrierung',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "register" */ '../views/Register')
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "resetPassword" */ '../views/ResetPassword')
  },
  {
    path: '/Account',
    name: 'Account',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '../views/Account'),
    // beforeEnter: (to, from, next) => {
    //     if(firebaseUtil.getUser()){
    //         next();
    //     }else{
    //         next(false);
    //     }
    // }
  },
  {
    path: '/Anmelden',
    name: 'Anmelden',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "signin" */ '../views/Signin'),
    // beforeEnter: (to, from, next) => {
    //     if(firebaseUtil.getUser()){
    //         console.log('??? beforeEnter in signin prevented');
    //         next(false);
    //     }else{
    //         next();
    //     }
    // }
  },
  {
    path: '/CheckoutTakeawayWithPay',
    name: 'checkouttakeAwayWithPay',
    meta: {
      title: 'Checkout'
    },
    component: CheckoutTakeawayMitOnlinePayment
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "checkouttakeAwayWithPay" */ '../views/CheckoutTakeawayMitOnlinePayment'),
  },
  {
    path: '/CheckoutDigitalOhnePayment',
    name: 'CheckoutDigitalOhnePayment',
    meta: {
      title: 'Checkout'
    },
    component: CheckoutDigitalOhnePayment
  },
  {
    path: '/CheckoutDigitalMitOnlinePayment',
    name: 'CheckoutDigitalMitOnlinePayment',
    meta: {
      title: 'Checkout'
    },
    component: CheckoutDigitalMitOnlinePayment
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "checkoutDigitalMitOnlinePayment" */ '../views/CheckoutDigitalMitOnlinePayment'),
  },
  {
    path: '/Checkoutdelivery',
    name: 'checkoutdelivery',
    meta: {
      title: 'Checkout'
    },
    // component: CheckoutDeliveryMitOnlinePayment
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "CheckoutDeliveryOhneOnlinePayment" */ '../views/CheckoutDeliveryOhnePayment'),
  },
  {
    path: '/CheckoutdeliveryWithPay',
    name: 'checkoutdeliveryWithPay',
    meta: {
      title: 'Checkout'
    },
    component: CheckoutDeliveryMitOnlinePayment,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "CheckoutDeliveryMitOnlinePayment" */ '../views/CheckoutDeliveryMitOnlinePayment'),
  },
  {
    path: '/CheckoutTakeaway',
    name: 'checkouttakeAway',
    meta: {
      title: 'Checkout'
    },
    component: CheckoutTakeawayOhnePayment
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "checkoutTakeawayOhnePayment" */ '../views/CheckoutTakeawayOhnePayment'),
  },
  {
    path: '/CheckoutKioskTakeAway',
    name: 'CheckoutKioskTakeAway',
    meta: {
      title: 'CheckoutKioskTakeAway'
    },
    component: CheckoutKioskTakeAway
  },
  {
    path: '/CheckoutInhouse',
    name: 'checkouttableOrdering',
    meta: {
      title: 'Checkout'
    },
    component: CheckoutInhouse
  },
  {
    path: '/CheckoutInhouseWithPay',
    name: 'checkouttableOrderingWithPay',
    meta: {
      title: 'Checkout'
    },
    component: CheckoutInhouseMitOnlinePayment
  },
  {
    path: '/CheckoutInhouseMitOnlinePaymentTip',
    name: 'checkouttableOrderingWithPayTip',
    meta: {
      title: 'Checkout'
    },
    component: CheckoutInhouseMitOnlinePaymentTip
  },
  {
    path: '/CheckoutKioskInhouse',
    name: 'CheckoutKioskInhouse',
    meta: {
      title: 'Checkout'
    },
    component: CheckoutKioskInhouse
  },
  {
    path: '/CheckoutKioskInhouseTip',
    name: 'CheckoutKioskInhouseTip',
    meta: {
      title: 'Checkout'
    },
    component: CheckoutKioskInhouseTip
  },
  // {
  //   path: '/MobileCheckoutInhouseWithPay',
  //   name: 'checkoutMobileInhouseWithPay',
  //   meta: {
  //     title: 'Mobile Checkout'
  //   },
  //   component: MobileCheckoutInhouseMitOnlinePayment
  // },


  {
    path: '/Kellnerruf',
    name: 'Kellnerruf',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "kellnerruf" */ '../views/Kellnerruf')
  },
  {
    path: '/KellnerrufErfolgreich',
    name: 'KellnerrufErfolgreich',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "kellnerrufErfolgreich" */ '../views/KellnerrufErfolgreich')
  },

  {
    path: '/Bestaetigung',
    name: 'Bestaetigung',
    // component: OrderSuccess
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "orderSuccess" */ '../views/OrderSuccess')
  },
  {
    path: '/Bestellung/:uniqueOrderId',
    name: 'Bestellung',
    component: OrderDetail,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "orderDetail" */ '../views/OrderDetail')
  },
  {
    path: '/Zahlungsmittel',
    name: 'Zahlungsmittel',
    component: PaymentMethods,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "paymentMethods" */ '../views/PaymentMethods'),
  },
  {
    path: '/Bestellungen',
    name: 'Bestellungen',
    meta: {
      title: 'Letzte Bestellungen'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "lastOrders" */ '../views/LastOrders')
  },
  {
    path: '/Favoriten',
    name: 'Favoriten',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "favorites" */ '../favorites/Favorites.vue'),
  },

  // {
  //     path: '/Coupons',
  //     name: 'Coupons',
  //     // route level code-splitting
  //     // this generates a separate chunk (about.[hash].js) for this route
  //     // which is lazy-loaded when the route is visited.
  //     component: () => import(/* webpackChunkName: "coupons" */ '../views/Coupons')
  // },
  // {
  //     path: '/Einloesen/:couponCode',
  //     name: 'Einloesen',
  //     meta: {
  //         title: 'Einlösen'
  //     },
  //     // route level code-splitting
  //     // this generates a separate chunk (about.[hash].js) for this route
  //     // which is lazy-loaded when the route is visited.
  //     component: () => import(/* webpackChunkName: "couponNow" */ '../views/CouponNow')
  // },

  {
    path: '/Impressum',
    name: 'Impressum',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "impressum" */ '../views/Impressum'),
  },
  {
    path: '/AGB',
    name: 'AGB',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "agb" */ '../views/AGB'),
  },
  {
    path: '/Datenschutz',
    name: 'Datenschutz',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "datenschutz" */ '../views/Datenschutz'),
  },
  {
    path: '/Allergene',
    name: 'Allergene',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "allergene" */ '../views/Allergene'),
  },
  {
    path: '/Stempelkarte',
    name: 'Stempelkarte',
    component: Stempelkarte,
  },
  {
    path: '/debugParams',
    name: 'debugParams',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "debugParams" */ '../views/debugParams'),
  },
  {
    path: '*',
    name: '404',
    component: NotFound
  },
]

const router = new VueRouter({
  // mode: 'history', //HTML5 mode
  base: process.env.BASE_URL,
  routes,

  scrollBehavior(to, from, savedPosition) {
    //   console.log('SCROLL savedPosition='+JSON.stringify(savedPosition));
    //   // return new Promise((resolve, reject) => {
    //   //   setTimeout(() => {
    //   //     resolve( savedPosition || { x: 0, y: 0 } )
    //   //   }, 500)
    //   // })
    //   return false
    util.setNoscroll(true);
    setTimeout(() => {
      util.setNoscroll(false);
    }, 100);

    if (to !== from) {
      // if(to.name !== 'Speise' && to.name !== 'Produkte')
      ebus.$emit('logPageView');
      // handleHashChange();
    }

    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }

  }
});

//navigation guard
//https://router.vuejs.org/guide/advanced/navigation-guards.html#global-before-guards
router.beforeEach((to, from, next) => {
  console.log('navigation from: ' + from.name + ' =========> ' + to.name);

  if (getGlobalValue('cashierAuth')) {
    if (from.name === 'Bestellungen' && to.name !== 'Bestellung'
      || from.name === 'Bestellung' && to.name !== 'Bestellungen'
    ) {
      console.log('remove cashierAuth');
      removeGlobalKey('cashierAuth');
    }
  }

  try {
    // if (navigationState.isPromoDialog()) {
    //     //close the dialog when pressing the native back button
    //     ebus.$emit('closePromoDialog');
    //     navigationState.setPromoDialog(false);
    //     next(false);
    // }

    // if (!to.name || !from || !from.name) {
    //     next(false);
    //     return;
    // }

    if (store.getters.showDialogContainer) {
      if (store.getters.secondSelectedDialog) {
        ebus.$emit('closedSecondDialogContainer', '' + store.getters.secondSelectedDialog);
        store.commit('secondSelectedDialog', ''); //triggers destroy of dialog
      } else {
        ebus.$emit('closedDialogContainer', '' + store.getters.selectedDialog);
        ebus.$emit('closedSecondDialogContainer', '' + store.getters.secondSelectedDialog);
        setTimeout(() => {
          store.commit('selectedDialog', ''); //triggers destroy of dialog
          store.commit('showDialogContainer', false);
        }, 100); //required for dialogs to react before beeing destroyed
      }

      // explicitly return false to cancel the navigation
      next(false);
      return false;
    }

    let dialogOpen = getGlobalValue('dialogOpen');
    if (getGlobalValue('dialogOpen')) {
      ebus.$emit('triggerCloseDialog' + dialogOpen);
      next(false);
      return;
    }

    if (navigationState.isNavGuardBlock()) {
      let t = navigationState.getNavGuardText();
      if (t) {
        ebus.$emit('toast', t);
      }
      next(false);
      return;
    }

    if (navigationState.isSidebar()) {
      //close the dialog when pressing the native back button
      ebus.$emit('closeSidebar');
      navigationState.setSidebar(false);
      next(false);
      return;
    }

    // if (to.name === 'Registrierung' && from.name !== 'Registrierung') {
    //     if (navigationState.isLoggedIn()) {
    //         ebus.$emit('toast', 'You are already logged in. Please logout first');
    //         return false;
    //     }
    // }

    if (to.name === 'Home' && from.name !== 'Home') {
      ebus.$emit('backHome');
    }

    next(true);
    return true;

  } catch (e) {
    console.log('Error in navigation guard: ' + e.message);
    next(true);
    return true;
  }
});

export default router
